<template>
  <div class="create-new-baseline">
    <div class="create-new-baseline__title">
      Create New Baseline
    </div>
    <div class="create-new-baseline__field create-new-baseline__field-label"
         :class="{ 'create-new-baseline__field_error': errorFields.label }">
      <div class="create-new-baseline__field_label">
        Label
        <span :style="{ color: label.length > 50 ? '#e11c21' : '#7c8e9b'}">{{ labelLength }}</span>
      </div>
      <input type="text"
             v-model="label"/>
      <span v-if="errorFields.label" class="create-new-baseline__field_error-message">{{ errorFields.label }}</span>
    </div>
    <div class="create-new-baseline__field-label">
      <ContentScreenModeSelect @screen="mode = $event"
                               class="create-new-baseline__screen-mode"/>
      <div class="content-elements__subtitle">{{ serpLabel }}</div>
      <GoogleSerpSimulator
        class="content-elements__serp"
        :url="truncatedUrl"
        :fullUrl="url"
        :title="title"
        :description="description"
        :mode="mode"/>
    </div>
    <div class="create-new-baseline__field create-new-baseline__field-label"
         :class="{ 'create-new-baseline__field_error': errorFields.title }">
      <div class="create-new-baseline__field_label">
        Title
        <span :style="{ color: title.length > 60 ? '#e11c21' : '#7c8e9b'}">{{ titleLength }}</span>
      </div>
      <input type="text"
             v-model="title"/>
      <span v-if="errorFields.title" class="create-new-baseline__field_error-message">{{ errorFields.title }}</span>
    </div>
    <div class="create-new-baseline__field create-new-baseline__field-label"
         :class="{ 'create-new-baseline__field_error': errorFields.description }">
      <div class="create-new-baseline__field_label">
        Meta Description
        <span :style="{ color: title.length > 160 ? '#e11c21' : '#7c8e9b'}">{{ descLength }}</span>
      </div>
      <textarea
        type="text"
        rows="1"
        ref="description"
        v-model="description"/>
      <span v-if="errorFields.description" class="create-new-baseline__field_error-message">{{ errorFields.description }}</span>
    </div>
    <base-content-block title="Keyword Cloud" class="create-new-baseline__keyword-cloud">
      <KeywordCloud />
    </base-content-block>
    <div class="create-new-baseline__field"
         :class="{ 'create-new-baseline__field_error': errorFields.body }">
      <div class="create-new-baseline__field_label">
        Body
      </div>
      <div ref="editor"
           class="create-new-baseline__field_input">
        <Editor
          v-model="body"
          :disabled="disableFields"
          :init="{
            verify_html: false,
            menubar: false,
            statusbar: false,
            plugins: 'advlist code autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
            toolbar: 'formatselect bold italic backcolor link bullist numlist image table code undo redo',
            height: '112',
            invalid_elements: 'style,script',
            setup (editor) {
              editor.on('init', resizeHandler.bind(this, true))
            }
          }"
        />
      </div>
      <div v-if="disableFields" class="create-new-baseline__field_loader">
        <base-loader/>
      </div>
      <span v-if="errorFields.body" class="create-new-baseline__field_error-message">{{ errorFields.body }}</span>
    </div>
    <div class="content-elements">
      <div class="content-elements__controls">
<!--        <button class="create-new-baseline__copy"-->
<!--                :class="{'create-new-baseline__copy_disabled': !optimized || disableFields || (optimized && optimized === body)}"-->
<!--                @click.prevent="cloneOptimized">-->
<!--          <base-material-design-icon icon="copy" />-->
<!--          clone current optimized-->
<!--        </button>-->
<!--        <button v-if="isPublished"-->
<!--                class="create-new-baseline__copy create-new-baseline__copy_from-url"-->
<!--                :class="{'create-new-baseline__copy_disabled': disableFields}"-->
<!--                @click.prevent="getPublishedUrlBaselineBody">-->
<!--          <base-material-design-icon icon="copy" />-->
<!--          import from published url-->
<!--        </button>-->
        <button class="content-elements__button content-elements__button_cancel"
                :class="{'create-new-baseline__copy_disabled': disableFields}"
                @click.prevent="close()">Cancel
        </button>
        <button class="content-elements__button content-elements__button_submit"
                :class="{'create-new-baseline__copy_disabled': disableFields}"
                @click.prevent="apply()">Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'
import Editor from '@tinymce/tinymce-vue'
import moment from 'moment'
import GoogleSerpSimulator from './GoogleSerpSimulator'
import ContentScreenModeSelect from './ContentScreenModeSelect'
import KeywordCloud from './KeywordCloud'
import ToastService from '@/services/toasterService'
import { mapActions } from 'vuex'
const image404 = require('@/assets/image-404.svg')

const EMPTY_ERROR_FIELDS = {
  label: '',
  body: ''
}

export default {
  name: 'CreateNewBaseline',
  mixins: [BaseModalMixins],
  components: { Editor, GoogleSerpSimulator, KeywordCloud, ContentScreenModeSelect },
  props: {
    optimized: {
      type: String,
      default: ''
    },
    titleOptimized: {
      type: String,
      default: ''
    },
    descriptionOptimized: {
      type: String,
      default: ''
    },
    briefId: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    invalidImageURLs: {
      type: Array,
      default: () => []
    },
    isPublished: {
      type: Boolean,
      default: false
    },
    saveAsBaseline: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.saveAsBaseline) {
      this.body = this.optimized || ''
      this.title = this.titleOptimized || ''
      this.description = this.descriptionOptimized || ''
      if (Object.values(this.errorFields).some(i => i)) {
        ToastService.showToast(ToastService.INFO_TYPE, 'To create a new baseline you first need to enter a Title Tag and Meta Description')
      }
    } else if (this.isPublished) {
      this.getPublishedUrlBaselineBody()
    }
    document.querySelector('.scrollable').addEventListener('scroll', this.handleEditorHeaderScroll)
    this.handleEditorHeaderScroll()
    this.localInvalidImageURLs = this.invalidImageURLs
  },
  beforeDestroy () {
    document.querySelector('.scrollable').removeEventListener('scroll', this.handleEditorHeaderScroll)
  },
  data () {
    return {
      label: moment(new Date()).format('YYYY-MM-DD LT'),
      body: '',
      title: '',
      description: '',
      baselineType: 'clone_optimized',
      disableFields: false,
      localInvalidImageURLs: [],
      styleAdded: false,
      imagesChecked: false,
      errorFields: { ...EMPTY_ERROR_FIELDS },
      mode: 'desktop'
    }
  },
  watch: {
    body (v) {
      this.validateImages()
      this.resizeHandler()
      if (!v) {
        this.baselineType = 'clone_optimized'
      }
      if (!this.imagesChecked) {
        this.handleImagesLoad()
      }
    },
    localInvalidImageURLs: {
      handler (v) {
        const div = document.createElement('div')
        div.innerHTML = this.body
        v.forEach(url => {
          const images = div.querySelectorAll(`img[src="${url}"]`) || []
          images.forEach(img => {
            img.src = image404
            img.setAttribute('width', '64px')
          })
        })
        if (div.innerHTML !== this.body) {
          this.body = div.innerHTML
        }
      },
      deep: true
    },
    description () {
      this.$nextTick(() => {
        const element = this.$refs.description
        if (element) {
          element.style.height = 'auto'
          element.style.height = element.scrollHeight - 68 + 'px'
        }
      })
    }
  },
  computed: {
    truncatedUrl () {
      if (!this.url) {
        return this.url
      }
      // remove protocol here
      const truncateUrl = this.url.replace(/(^\w+:|^)\/\//, '')
      if (truncateUrl.length <= 60) {
        return truncateUrl
      }
      const splitedUrl = truncateUrl.split('/')
      const lastSymbolsCount = 57 - splitedUrl[0].length
      return `${splitedUrl[0]}...${truncateUrl.slice(truncateUrl.length - lastSymbolsCount)}`
    },
    titleLength () {
      const titleLength = this.title.length
      return titleLength ? `${titleLength} of 60 characters` : '60 characters max'
    },
    descLength () {
      const descLength = this.description.length
      return descLength ? `${descLength} of 160 characters` : '160 characters max'
    },
    labelLength () {
      const labelLength = this.label.length
      return labelLength ? `${labelLength} of 50 characters` : '50 characters max'
    },
    isUrlImport () {
      return this.baselineType === 'url_import'
    },
    serpLabel () {
      return this.saveAsBaseline ? 'Optimized' : 'Published'
    }
  },
  methods: {
    ...mapActions('briefContent', ['getUrlBaselineBody']),
    close () {
      this.$emit('close')
    },
    handleEditorHeaderScroll () {
      const editor = this.$refs['editor']
      if (!editor) return
      const editorRect = editor.getBoundingClientRect()
      const header = editor.querySelector('.mce-top-part')
      header.style.width = '100%'
      if (editorRect.y >= 0) {
        header.style.top = '0px'
      } else if (Math.abs(editorRect.y) >= editorRect.height - 200) {
        const top = editorRect.height - 200
        header.style.top = top + 'px'
      } else {
        header.style.top = Math.abs(editorRect.y + 1) + 'px'
      }
    },
    validateContent (content) {
      const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi
      const styleRegex = /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi
      return content.replace(scriptRegex, '').replace(styleRegex, '')
    },
    async handleImagesLoad () {
      await this.$nextTick()
      const interval = setInterval(() => {
        const iFrame = this.$refs.editor.firstChild.querySelector('iframe')
        const imgs = iFrame.contentDocument.body.querySelectorAll('img')
        let isAllImagesLoaded = true
        for (const img of imgs) {
          if (!img.complete) {
            isAllImagesLoaded = false
            break
          }
        }
        if (isAllImagesLoaded) {
          clearInterval(interval)
          this.resizeHandler()
        }
      }, 500)
    },
    async validateImages () {
      const editorParent = this.$refs.editor
      if (editorParent) {
        const iframe = editorParent.querySelector('iframe')
        await this.$nextTick()
        const body = iframe.contentWindow.document.body
        const images = body.querySelectorAll('img')
        images.forEach(img => {
          img.removeAttribute('onerror')
          img.removeAttribute('onload')
          img.addEventListener('error', () => {
            this.localInvalidImageURLs.push(img.getAttribute('src'))
            img.addEventListener('load', () => {
              this.resizeHandler()
            })
          })
        })
        iframe.contentWindow.document.body = body
      }
    },
    apply () {
      this.errorFields = { ...EMPTY_ERROR_FIELDS }
      if (!this.label.trim()) {
        this.errorFields.label = 'Label field is required'
      }
      if (!this.body.trim()) {
        this.errorFields.body = 'Body field is required'
      }
      if (!Object.values(this.errorFields).some(i => i)) {
        this.$emit('close', {
          label: this.label,
          body: this.validateContent(this.body),
          title: this.title,
          description: this.description,
          fk_category_id: this.baselineType
        })
      }
    },
    async getPublishedUrlBaselineBody () {
      this.disableFields = true
      const { content = '', title = '', description = '' } = await this.getUrlBaselineBody(this.briefId)
      this.disableFields = false
      if (content) {
        this.baselineType = 'url_import'
        Object.assign(this, { body: content, title, description })
      }
    },
    resizeHandler (validateImages = false) {
      validateImages && this.validateImages()
      const iframe = this.$refs.editor.firstChild.querySelector('iframe')
      if (!iframe) {
        return
      }
      if (!this.styleAdded) {
        this.styleAdded = true
        const style = document.createElement('style')
        style.innerHTML = `
          img {
            max-width: 100% !important;
          }
        `
        iframe.contentWindow.document.head.appendChild(style)
      }
      this.$nextTick(() => {
        const iframeHeight = iframe.contentWindow.document.body.offsetHeight
        const height = iframeHeight > 112 ? iframeHeight : 68
        iframe.setAttribute('style', `height: ${height + 44}px; width: -webkit-fill-available; padding: 8px;`)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .create-new-baseline {
    padding: 40px;

    &__screen-mode {
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
      margin-bottom: -52px;
    }

    &__copy {
      border: none;
      outline: none;
      background: transparent;
      text-transform: uppercase;
      line-height: 24px;
      font-size: 10px;
      display: flex;
      align-items: center;
      color: $rfx-dark-march;
      font-weight: 900;
      cursor: pointer;

      span {
        font-size: 15px;
        padding-right: 13px;
      }

      &_from-url {
        margin-left: 45px;
      }

      &_disabled {
        pointer-events: none;
        cursor: default;
        opacity: .4;
      }
    }

    &__title {
      font-size: 32px;
      color: $rfx-dark-march;
      line-height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto 40px;
      letter-spacing: -0.32px;
      font-weight: bold;
    }

    &__keyword-cloud {
      margin-top: 24px;
      margin-bottom: 24px;
    }

    &__field {
      &_label {
        font-size: 14px;
        color: $rfx-dark-march;
        font-weight: 500;
        letter-spacing: -0.12px;
        margin-bottom: 12px;

        span {
          color: $rfx-shaded-grey;
          font-weight: normal;
          padding-left: 8px;
        }
      }

      &_loader {
        border-radius: 13px;
        position: absolute !important;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;

        .lds-ring {
          margin: auto;
        }
      }

      &-label {
        margin-bottom: 24px;
      }

      &_error {
        .create-new-baseline__field_input,
        textarea,
        input {
          border-color: $rfx-red !important;
        }

        &-message {
          color: $rfx-red;
          font-size: 10px;
          margin-top: 5px;
          padding-left: 0;
        }
      }

      textarea,
      input {
        border: solid 1px #dbdee5;
        outline: none;
        resize: none;
        padding: 16px;
        width: -webkit-fill-available;
        border-radius: 4px;
        font-size: 16px;
        line-height: 20px;
        color: $rfx-dark-march;
        grid-area: input;
      }

      &_input {
        border: solid 1px #dbdee5;
        border-radius: 4px;
        overflow: hidden;

        &::v-deep .mce-panel {
          box-shadow: none !important;
          border: none !important;

          .mce-top-part {
            padding-left: 7px;
          }
        }
      }
    }

    .content-elements {
      padding: 0;

      &__controls {
        margin-top: 40px;
      }

      &__button_cancel {
        margin-left: auto;
        background-color: transparent;
      }
    }
  }
</style>
